import React from "react";
import AboutPromo from "../pages/AboutPromo";
import PromoArea from "../pages/PromoArea";

const AboutPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3>About Us</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-page-area section_70">
        <div className="container">
          <div className="row">

            {/* Left Side */}
            <div className="col-lg-6">
              <div className="about-page-left">
                <h4>About Us</h4>
                <h3>Committed to Safe and Reliable Ride Solutions</h3>

              <p>
  <span>Since 2012</span>, Shambhu Cabs, based in Navi Mumbai, has been providing
  trusted and reliable taxi services across the city and throughout India.
  With professional drivers and well-maintained vehicles, we ensure safe,
  comfortable, and timely journeys for every customer.
</p>

<p>
  From airport transfers and local city rides to outstation trips and
  all-India travel, Shambhu Cabs is committed to making every journey smooth,
  convenient, and stress-free — no matter where your destination is.
</p>


                <div className="about-page-call">
                  <div className="page-call-icon">
                    <i className="fa fa-phone"></i>
                  </div>
                  <div className="call-info">
                    <p>Need any help?</p>
                    <h4>
                      <a href="tel:+919819399797">(+91) 9819399797</a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side */}
            <div className="col-lg-6">
              <div className="about-page-right">
                <img src="/img/about-page.jpg" alt="Shambhu Cabs About Us" />
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Promo Sections */}
      <AboutPromo />
      <PromoArea />
    </>
  );
};

export default AboutPage;
